@if (registrationHistoryDate?.count! > 0) {
  <div
    id="divChart"
    class="chart-container"
    >
    <canvas id="registrationHistoryDate"> </canvas>
  </div>
}
